import React from 'react';
import { Box } from '@mui/material';

const CPA_AND_TAX_POSTS = new Set([
    'why-cpa-teams-struggle-during-tax-season',
    'where-is-your-last-w-2-right-now',
    'ai-in-tax-preparation-replacing-data-entry-not-tax-professionals',
    'the-real-roi-of-tax-workflow-automation',
    'the-client-experience-gap-in-modern-tax-firms',
]);

const PACK_13_RELATED_POSTS = {
    'why-cpa-teams-struggle-during-tax-season': [
        { href: '/blog/best-client-portal-software-buyers-guide/', anchor: 'How to choose client portal software' },
        { href: '/blog/client-portal-for-accountants/', anchor: 'How accountants can choose a client portal' },
    ],
    'the-hidden-cost-of-just-send-me-that-file': [
        { href: '/blog/best-client-portal-software-buyers-guide/', anchor: 'How to choose client portal software' },
        { href: '/blog/secure-file-sharing-for-law-firms/', anchor: 'Secure file sharing for law firms' },
        { href: '/blog/client-portal-for-accountants/', anchor: 'How accountants can choose a client portal' },
    ],
    'why-secure-document-management-is-essential-for-every-business': [
        { href: '/blog/secure-file-sharing-for-law-firms/', anchor: 'Secure file sharing for law firms' },
    ],
};

export const getRelatedCluster = (slug) => CPA_AND_TAX_POSTS.has(slug)
    ? {
        href: 'https://safevaultusa.com/providers',
        anchor: 'Secure document collaboration for tax professionals',
    }
    : {
        href: '/faq',
        anchor: 'Common questions about SafeVault security and access',
    };

const BlogPostRelated = ({ slug }) => {
    const cluster = getRelatedCluster(slug);
    const relatedPosts = PACK_13_RELATED_POSTS[slug] || [];

    return (
        <Box component="section" className="post-related" aria-labelledby="post-related-heading">
            <h2 id="post-related-heading">Explore SafeVault</h2>
            <ul>
                <li><a href="/our-products">Vaults, DocIQ, and Flows: how SafeVault works</a></li>
                <li><a href={cluster.href}>{cluster.anchor}</a></li>
                <li><a href="/schedule-demo">Schedule a SafeVault demo</a></li>
                {relatedPosts.map((post) => (
                    <li key={post.href}><a href={post.href}>{post.anchor}</a></li>
                ))}
            </ul>
        </Box>
    );
};

export default BlogPostRelated;
